<template>
  <div id="container" class="cs_st apply_st grid-container">
    <Sidebar />
    <BaseLocation current-group-name="onlyNormal" />
    <div class="section">
      <div class="inner">
        <div class="box_wrap">
          <div class="box tac">
            <div ref="focus" class="box_title">
              <h2>체험판 코드 입력</h2>
              <p class="guide_txt">
                등록할 체험판 도서 코드를 입력해주세요.
              </p>
            </div>
            <div class="apply_formlist">
              <ul class="form_wrap">
                <li>
                  <p class="subtitle base_NM24 necessary">
                    ※ 체험판 코드
                  </p>
                  <input
                    v-model="couponNo"
                    type="text"
                    placeholder=""
                    class="input_t"
                  />
                </li>
              </ul>
            </div>
            <div class="btn_wrap">
              <button class="box_btn" @click="requestCoupon">
                <span class="an_t">받기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- ERROR MODAL START -->

    <transition name="modal-fade">
      <Modal v-if="showErrorModal">
        <div
          v-on-clickaway="isErrors ? closeModal : returnRoute"
          class="ly_pop_wrap"
        >
          <div class="ly_pop_content ly_pop_msg ly_txt ly_alert">
            <div class="ly_inner">
              <p>
                {{ modalTitleTxt }}
              </p>
              <div v-if="isErrors" class="btnWrap">
                <button class="box_btn" @click="closeModal">
                  <span class="an_t">확인</span>
                </button>
              </div>
              <div v-else class="btnWrap">
                <button class="box_btn wt" @click="returnRoute">
                  <span class="an_t">확인</span>
                </button>
                <button class="box_btn" @click="toLibrary">
                  <span class="an_t">내 서재 바로가기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL END -->
  </div>
</template>
<script>
export default {
  name: 'CouponSecond',
  data() {
    return {
      isErrors: false,
      searchTxt: '',
      modalMsg: '',
      modalSubMsg: '',
      modalTitleTxt: '',
      isShowModal: false,
      showErrorModal: false,
      couponNo: ''
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // if (this.$store.getters.getCurrentUser.memberTp !== '1000') {
    //   this.toggleErrorModal(`일반회원 페이지입니다.`, false)
    // }
  },
  destroyed() {},
  methods: {
    async requestCoupon() {
      await this.$store
        .dispatch('requestCoupone', {
          // memberTp: this.getCurrentUser?.memberTp,
          purchaseTp: 'CPN',
          couponNo: this.couponNo
        })
        .then((res) => {
          if (res.data.ok) {
            this.toggleErrorModal(
              `쿠폰 적용이 완료되었습니다.
              내 서재 → 체험판 도서 서재에서 이용이 가능합니다.`,
              false
            )
          }
        })
        .catch((err) => {
          if (err.response) {
            this.toggleErrorModal(
              `[${err.response.data.errorState.code}] ${err.response.data.errorState.reason}`,
              true
            )
          }
        })
    },
    closeModal() {
      this.showErrorModal = false
    },
    returnRoute() {
      this.closeModal()
      this.$router.push({
        name: 'store'
      })
    },
    toLibrary() {
      this.closeModal()
      this.$router.push({
        name: 'library_default'
      })
    },
    toggleErrorModal(msg, isErr) {
      this.modalTitleTxt = msg || '*필수항목을 모두 입력해주세요.'
      this.isErrors = isErr
      this.showErrorModal = !this.showErrorModal
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.input_t_wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0px 12px;
}
.t_20 {
  top: 20% !important;
}
// 학지추가
// .section .inner {
//   padding: 132px 0 124px;
// }
.apply_st .box_wrap {
  margin: 0 auto;
  padding-bottom: 89px;
}
.apply_st .box_wrap,
.apply_st .box_wrap .box {
  width: 100%;
  max-width: 920px;
}
.guide_txt {
  font-size: 28px;
  line-height: 30px;
}
.apply_formlist {
  text-align: left;
  margin-bottom: 20px;
  .form_wrap {
    li {
      display: flex;
      align-items: center;
      p {
        flex: 1 0 auto;
        max-width: 140px;
        min-width: 140px;
      }
      .necessary {
        color: red;
      }
      + .mt_12 {
        margin-top: 8px;
        color: $h_BLUE_01;
      }
      .box_btn {
        white-space: nowrap;
        height: 100%;
        color: $white;
        padding: 11px 26px 14px;
      }
      input {
        flex: 1;
      }
      .btn_wrap {
        display: flex;
        flex: 1;
      }
    }
    .before_wrap {
      .input_t_wrap {
        width: 100%;
      }
    }
  }
}
.box_wrap {
  .btn_wrap {
    .box_btn {
      .an_t {
        font-size: 24px;
      }
    }
  }
}

//******//
//******//
//******//
.ly_alert {
  width: 540px;
  padding: 65px 58px 60px;
}
.ly_alert .ly_inner {
  padding: 0 !important;
  text-align: center;
  background-color: #f0f5fa !important;
}
.ly_alert .ly_inner strong {
  padding-top: 83px;
  padding-bottom: 8px;
  display: block;
}
.ly_alert .ly_inner p {
  color: #627283;
  font-size: 16px;
  margin-top: 0;
  letter-spacing: -0.03em;
  word-break: keep-all;
  white-space: pre-line;
}
.ly_alert .ly_inner .btnWrap {
  margin-top: 24px;
  .box_btn.wt {
    background-color: #eaeaea;
    border: 1px solid #eaeaea;
    margin-right: 20px;
    .an_t {
      color: #545454;
    }
  }
}

.box_wrap .box + .box {
  position: relative;
  padding: 40px 56px 0px 56px;
  margin-top: 40px;
  border-top: 1px solid #d6e7f1;
}

.form_wrap > li + li {
  margin-top: 20px;
}
@media (max-width: 1024px) {
  .box_wrap {
    padding: 48px 0px !important;
    border-radius: 20px;
  }
}
@media (max-width: 768px) {
  .apply_formlist {
    .form_wrap {
      li {
        flex-direction: column;
        align-items: flex-start;
        p {
          margin-bottom: 1rem;
        }
        + .mt_12 {
          margin-top: 8px;
          color: $h_BLUE_01;
        }
        .box_btn {
          white-space: nowrap;
          height: 100%;
          color: $white;
          padding: 11px 26px 14px;
        }
        input,
        .btn_wrap {
          flex: 1;
          width: 100%;
        }
      }
    }
  }
  .ly_alert {
    .ly_inner {
      p {
        font-size: 22px;
      }
      .btnWrap {
        .box_btn {
          padding: 0px 40px;
          height: 60px;
          .an_t {
            line-height: 60px;
            font-size: 20px;
          }
        }
        .box_btn.wt {
          margin-right: 0px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
@media (max-width: 526px) {
  .apply_formlist .form_wrap .before_wrap p {
    position: static;
    min-height: 48px;
    transform: translateY(-5%);
  }
  .before_wrap {
    padding: 0 !important;
    .input_t_wrap {
      width: 100%;
    }
  }
}
</style>
